<template>
    <v-row>
        <v-col
            cols="12"
            sm="8"
            md="6"
            lg="6"
            xl="4"
            offset-sm="2"
            offset-md="3"
            offset-lg="3"
            offset-xl="4"
            class="mt-4"
        >
            <v-card>
                <v-card-title class="text-center">
                    <h2>Login</h2>
                </v-card-title>
                <v-card-text>
                    <p class="text-center mb-3">
                        Bitte melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem selbst gewählten
                        Passwort an.
                    </p>
                    <v-form novalidate @submit.prevent>
                        <v-text-field
                            id="username"
                            v-model="username"
                            autofocus
                            type="text"
                            label="vorname.nachname@hs-anhalt.de"
                            name="username"
                            data-test="username"
                            autocomplete="username email"
                            prepend-inner-icon="mdi-email"
                            prepend-icon=""
                            density="compact"
                            variant="outlined"
                            color="primary"
                            base-color="primary"
                            hide-details
                            class="mb-3"
                        />
                        <v-alert v-if="false === validation" type="warning" class="mb-3">
                            {{ usernameHelp }}
                        </v-alert>
                        <v-text-field
                            v-model="password"
                            prepend-inner-icon="mdi-lock-outline"
                            :append-inner-icon="
                                isPasswordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                            "
                            :type="passwordFieldType"
                            :disabled="isLoading"
                            label="Passwort"
                            placeholder="Passwort"
                            name="password"
                            data-test="password"
                            autocomplete="password"
                            density="compact"
                            variant="outlined"
                            color="primary"
                            base-color="primary"
                            hide-details
                            class="mb-3"
                            @click:append-inner="switchPasswordVisibility"
                        />
                        <v-btn
                            :disabled="username.length < 10 || password.length < -1 || isLoading"
                            block
                            color="secondary"
                            type="submit"
                            data-test="btn-anmelden"
                            :loading="isLoading"
                            class="mb-3"
                            @click="performLogin()"
                        >
                            Anmelden
                        </v-btn>
                        <v-alert v-if="hasError" type="warning" class="mb-3">
                            {{
                                'Die Kombination aus LERNLEITSTAND-Nutzername und Passwort ist ungültig.'
                            }}
                            <br />
                            {{
                                'Falls Sie weiterhin Probleme haben, nutzen Sie die untenstehende Passwort-Vergessen-Funktion.'
                            }}
                        </v-alert>
                        <router-link
                            class="btn btn-link"
                            :to="{ name: 'PasswordReset', params: { usernameFromLogin: username } }"
                        >
                            Passwort vergessen oder noch kein Passwort?
                        </router-link>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import * as EmailValidator from 'email-validator'
    ;('use strict')
    export default {
        name: 'Login',
        data: () => ({
            username: '',
            password: '',
            usernameHelp: 'Ihre E-Mail-Adresse ist keine gültige E-Mail-Adresse.',
            passwordHelp: '',
            passwordFieldType: 'password',
            isPasswordVisible: false
        }),
        computed: {
            isLoading() {
                return this.$store.getters['security/isLoading']
            },
            hasError() {
                return this.$store.getters['security/hasError']
            },
            error() {
                return this.$store.getters['security/error']
            },
            validation() {
                if (this.username.trim().length <= 10) {
                    // an email is at least 10 chars in length and we do not want to trigger js validation before
                    return null
                }

                return EmailValidator.validate(this.username.trim())
            }
        },
        created() {
            let redirect = this.$route.query.redirect

            if (this.$store.getters['security/isAuthenticated']) {
                if (typeof redirect !== 'undefined') {
                    this.$router.push({ path: redirect })
                } else {
                    this.$router.push({ name: 'ModulhandbuchPage' })
                }
            }
        },
        methods: {
            async performLogin() {
                if ('text' === this.passwordFieldType) {
                    // ensure that password can be saved via browser
                    this.switchPasswordVisibility()
                }
                let payload = { username: this.$data.username, password: this.$data.password },
                    redirect = this.$route.query.redirect

                await this.$store.dispatch('security/login', payload)
                if (!this.$store.getters['security/hasError']) {
                    if (typeof redirect !== 'undefined') {
                        this.$router.push({ path: redirect })
                    } else {
                        this.$router.push({ name: 'ModulhandbuchPage' })
                    }
                }
            },
            switchPasswordVisibility() {
                this.passwordFieldType = 'text' === this.passwordFieldType ? 'password' : 'text'
                this.isPasswordVisible = 'text' === this.passwordFieldType
            }
        }
    }
</script>

<style scoped></style>
